export default __webpack_public_path__ + "static/media/Animals17.58a91822.jpg";